import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled", "onClick"]
const _hoisted_2 = ["aria-expanded", "aria-label"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSearch = _resolveComponent("SharedSearch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('toolbar'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('tabs')),
        ref: "tabs"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('tab-pill')),
          ref: "pill"
        }, null, 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.id,
            ref_for: true,
            ref: "tabButtons",
            class: _normalizeClass(_ctx.b('tab', { active: tab.acitve })),
            disabled: tab.isDisabled,
            onClick: ($event: any) => (_ctx.handleTab(tab))
          }, _toDisplayString(_ctx.$t(tab.label)), 11, _hoisted_1))
        }), 128))
      ], 2),
      _createVNode(_component_SharedSearch, {
        class: _normalizeClass(_ctx.b('search')),
        search: _ctx.displayedSearch.value,
        placeholder: "Поиск по операциям",
        "onUpdate:search": _ctx.handleSearch
      }, null, 8, ["class", "search", "onUpdate:search"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('actions'))
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(
            _ctx.b('button', { filter: true, active: _ctx.isFilterOpen || _ctx.hasFilter })
          ),
          "aria-expanded": _ctx.isFilterOpen,
          "aria-label": _ctx.$t('Фильтры'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFilter && _ctx.handleFilter(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('button-icon')),
            innerHTML: _ctx.displayedIcons.filter
          }, null, 10, _hoisted_3)
        ], 10, _hoisted_2),
        (_ctx.hasFilter)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(_ctx.b('button', { clear: true })),
              "aria-label": _ctx.$t('Очистить фильтры'),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClearFilter && _ctx.handleClearFilter(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('button-icon')),
                innerHTML: _ctx.displayedIcons.clear
              }, null, 10, _hoisted_5)
            ], 10, _hoisted_4))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2))
}